import type { ReactNode } from 'react';

import { tokens, Link } from '@hotjar/hotsauce';
import { css } from '@emotion/react';

interface Props {
  onUpsellClick: () => unknown;
  children: ReactNode;
  alternateStyling?: boolean;
}

export const GenericUpsellMessage = ({
  onUpsellClick,
  children,
  alternateStyling,
}: Props): JSX.Element => {
  const linkColor = alternateStyling ? tokens.color.link : tokens.color.lemon;
  return (
    <span data-testid="top-bar-generic-upsell-message">
      <Link
        as="button"
        kind="inline"
        id="showUpsellModalSiteBar"
        css={css`
          color: ${linkColor};
          &:hover {
            color: ${linkColor};
          }
        `}
        onClick={onUpsellClick}
      >
        {children as string}
      </Link>{' '}
    </span>
  );
};
